import Vue from 'vue'
import VueRouter from 'vue-router'
import SPA from '@/pages/SPA.vue'
import LOGIN from '@/pages/LOGIN.vue'
import MenuHome from '@/components/menus/MenuHome.vue'
import MenuAes from '@/components/menus/MenuAes.vue'
import MenuSnowflake from '@/components/menus/MenuSnowflake.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LOGIN
  },
  {
    path: '/spa',
    component: SPA,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: MenuHome
      },
      {
        path: 'aes',
        name: 'AES',
        component: MenuAes
      },
      {
        path: 'snowflake',
        name: 'Snowflake',
        component: MenuSnowflake
      },
      {
        path: '',
        redirect: 'home'
      }
    ]
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router 